import { render } from "./StudentPlaceLesson.vue?vue&type=template&id=3025b0c1"
import script from "./StudentPlaceLesson.vue?vue&type=script&lang=js"
export * from "./StudentPlaceLesson.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__